import { App } from "@capacitor/app";
import { PLATFORM_IS_NATIVE } from "src/hybrid/components/Platform";

type CleanupFn = () => void;
type ActiveChangeCallback = (isActive: boolean) => void;

function onAppActiveChangeNative(callback: ActiveChangeCallback): CleanupFn {
  const promise = App.addListener("appStateChange", (state) => {
    callback(state.isActive);
  });

  return () => {
    void promise.then((listener) => listener.remove());
  };
}

function onAppActiveChangeWeb(callback: ActiveChangeCallback): CleanupFn {
  const handler = () => {
    callback(document.visibilityState === "visible");
  };
  document.addEventListener("visibilitychange", handler);
  return () => document.removeEventListener("visibilitychange", handler);
}

export function onAppActiveChange(callback: ActiveChangeCallback): CleanupFn {
  if (PLATFORM_IS_NATIVE) {
    return onAppActiveChangeNative(callback);
  }
  return onAppActiveChangeWeb(callback);
}

export function onAppActive(callback: () => void): CleanupFn {
  return onAppActiveChange((isActive) => {
    if (isActive) {
      callback();
    }
  });
}

export function onAppInactive(callback: () => void): CleanupFn {
  return onAppActiveChange((isActive) => {
    if (!isActive) {
      callback();
    }
  });
}
